import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { aiProactivePluginKey } from './ai-proactive-plugin-key';
// import { DOC_CHANGE_COUNT_LIMIT } from './constants';
import { regenerateAllDecorations, regenerateSelectionDecorations } from './decorations';
import { reducer } from './reducer';
import { findProactiveAIBlockToUpdate, getAllProactiveAIBlocks } from './utils';
var handleDocChanged = function handleDocChanged(tr, pluginState, newEditorState) {
  var _tr$getMeta$uniqueInt, _tr$getMeta;
  var _findProactiveAIBlock = findProactiveAIBlockToUpdate(tr, pluginState, newEditorState),
    updatedProactiveAIBlock = _findProactiveAIBlock.updatedProactiveAIBlock;
  var decorationSet = pluginState.decorationSet,
    selectedID = pluginState.selectedID;
  var uniqueInteractionID = (_tr$getMeta$uniqueInt = (_tr$getMeta = tr.getMeta(aiProactivePluginKey)) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.uniqueInteractionID) !== null && _tr$getMeta$uniqueInt !== void 0 ? _tr$getMeta$uniqueInt : selectedID;
  return _objectSpread(_objectSpread({}, pluginState), {}, {
    selectedID: uniqueInteractionID,
    decorationSet: regenerateAllDecorations({
      decorationSet: decorationSet,
      tr: tr,
      pluginState: _objectSpread(_objectSpread({}, pluginState), {}, {
        proactiveAIBlocks: updatedProactiveAIBlock
      })
    }),
    proactiveAIBlocks: updatedProactiveAIBlock
    // ...(docChangeCountUntilLimit < DOC_CHANGE_COUNT_LIMIT && {
    // 	docChangeCountUntilLimit: docChangeCountUntilLimit + 1,
    // }),
  });
};
var handleSelectionChanged = function handleSelectionChanged(tr, pluginState) {
  var decorationSet = pluginState.decorationSet;
  return _objectSpread(_objectSpread({}, pluginState), {}, {
    decorationSet: regenerateSelectionDecorations({
      decorationSet: decorationSet,
      tr: tr,
      pluginState: pluginState
    })
  });
};
export var createInitialState = function createInitialState(_ref) {
  var proactiveAIApiUrl = _ref.proactiveAIApiUrl,
    documentSGChecker = _ref.documentSGChecker,
    defaultToggledState = _ref.defaultToggledState,
    product = _ref.product;
  return function (state) {
    var _getAllProactiveAIBlo = getAllProactiveAIBlocks(state),
      proactiveAIBlocks = _getAllProactiveAIBlo.proactiveAIBlocks;
    var initialToggleState = !!defaultToggledState;
    return {
      product: product,
      proactiveAIBlocks: proactiveAIBlocks,
      initialToggleState: initialToggleState,
      isProactiveEnabled: true,
      isProactiveContextPanelOpen: false,
      // was: initialToggleState
      alwaysDisplayProactiveInlineDecorations: true,
      decorationSet: DecorationSet.empty,
      proactiveAIApiUrl: proactiveAIApiUrl,
      dismissedWords: new Set(),
      toggleCount: initialToggleState ? 1 : 0,
      insertionCount: 0,
      documentSGChecker: documentSGChecker,
      docChangeCountUntilLimit: 0,
      isFirstInitiatedEventSent: false
    };
  };
};
var _pluginFactory = pluginFactory(aiProactivePluginKey, reducer, {
    onDocChanged: handleDocChanged,
    onSelectionChanged: handleSelectionChanged
  }),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand,
  getPluginState = _pluginFactory.getPluginState;
export { createPluginState, createCommand, getPluginState };